import React, {memo, useCallback, useEffect} from "react"
import {toast, ToastContainer} from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"
import {useDispatch, useSelector} from "react-redux"
import {setMessage} from "../store/appReducer"
import {StateType} from "../store/store"
import alarm from "../assets/sounds/alarm.mp3"
import warning from "../assets/sounds/warning.mp3"
import info from "../assets/sounds/info.mp3"
import useSound from "use-sound"

const volume = 0.3

export const NotifierGenerator = memo(() => {
    const dispatch = useDispatch()
    const {type, message, sound} = useSelector((state: StateType) => state.appReducer.message)
    const [playAlarm] = useSound(alarm, {volume})
    const [playWarning] = useSound(warning, {volume})
    const [playInfo] = useSound(info, {volume})

    const notify = useCallback(() => toast(message, {
        type: type || 'default',
    }), [message, type])

    useEffect(() => {
        if (message) {
            notify()
            if (sound) {
                if (type === 'info') playInfo()
                if (type === 'warning') playWarning()
                if (type === 'error') playAlarm()
            }
            dispatch(setMessage({type: '', message: '', sound: false}))
        }
    }, [dispatch, notify, message, type, sound])

    return (
        <ToastContainer limit={10}
                        position="top-right"
                        theme="colored"
                        pauseOnFocusLoss={false}
                        autoClose={5000}
                        style={{wordBreak: 'break-word', fontSize: 14, whiteSpace: 'pre-wrap'}}
        />
    )
})
